
import { windowatch } from '../../../scripts/lib/windowatch';

export default class Navigation {

  constructor ($el) {
    this.$el = $el;

    // state
    this.expanded = false;
    this.sticky = false;
    this.hidden = false;
    this.multiColumnLayout = false;

    this.lastScrollY = 0;
    this.deltaScrollY = 0;

    // collect items
    this.$list = $el.querySelector('.navigation__list');
    this.$secondList = null;
    this.$items = [...$el.querySelectorAll('.navigation__item')];
    this.$itemLabels =
      this.$items.map($item => $item.querySelector('.navigation__item-label'));
    this.$itemToggles =
      this.$items.map($item => $item.querySelector('.navigation__item-toggle'));

    this.$buttonMenu = $el.querySelector('.navigation__button-menu');
    this.$buttonClose = $el.querySelector('.navigation__button-close');

    // bind item events
    this.$items.forEach(($toggle, index) => {
      if (this.$itemLabels[index]) {
        this.$itemLabels[index].addEventListener('mouseenter',
          this.onItemMouseEnter.bind(this));
      }
      if (this.$itemToggles[index]) {
        this.$itemToggles[index].addEventListener('click',
          this.onItemToggleClick.bind(this, this.$itemToggles[index]));
      }
    });

    // bind menu events
    this.$el.addEventListener('mouseleave', this.onMenuMouseLeave.bind(this));

    // bind button events
    this.$buttonMenu.addEventListener('click',
      this.onMenuToggleClick.bind(this));
    this.$buttonClose.addEventListener('click',
      this.onMenuToggleClick.bind(this));

    // bind scroll and resize events
    windowatch.addScrollListener(this.onScroll.bind(this));
    windowatch.addBreakpointListener(this.onBreakpointChange.bind(this));
  }

  setSticky (sticky) {
    if (this.sticky !== sticky) {
      this.sticky = sticky;
      if (sticky) {
        this.$el.classList.add('navigation--sticky');
      } else {
        this.$el.classList.remove('navigation--sticky');
      }
    }
  }

  setHidden (hidden) {
    if (this.hidden !== hidden) {
      this.hidden = hidden;
      if (hidden) {
        this.$el.classList.add('navigation--hidden');
      } else {
        this.$el.classList.remove('navigation--hidden');
      }
    }
  }

  setExpanded (expanded) {
    if (this.expanded !== expanded) {
      this.expanded = expanded;
      if (expanded) {
        this.$el.classList.add('navigation--expanded');
      } else {
        this.$el.classList.remove('navigation--expanded');
      }
    }
  }

  onItemToggleClick ($toggle, evt) {
    evt.preventDefault();
    const toggleIndex = this.$itemToggles.indexOf($toggle);
    this.$items.forEach(($item, index) => {
      if (index === toggleIndex) {
        $item.classList.toggle('navigation__item--open');
      } else {
        $item.classList.remove('navigation__item--open');
      }
    });
  }

  onMenuToggleClick (evt) {
    evt.preventDefault();
    this.setExpanded(!this.expanded);
  }

  onItemMouseEnter (evt) {
    this.setExpanded(true);
  }

  onMenuMouseLeave (evt) {
    this.setExpanded(false);
  }

  onScroll () {
    const breakpoint = windowatch.getBreakpoint();
    const scrollY = windowatch.getScrollY();
    const scrollDelta = scrollY - this.lastScrollY;

    this.setSticky(
      (['xs', 's', 'm'].indexOf(breakpoint) !== -1 && scrollY > 0) ||
      scrollY > 32);

    if (!this.expanded && this.sticky) {

      if ((this.deltaScrollY >= 0) !== (scrollDelta >= 0)) {
        this.deltaScrollY = scrollDelta;
      } else {
        this.deltaScrollY += scrollDelta;
      }

      if (this.deltaScrollY > 100) {
        this.setHidden(true);
      }

      if (this.deltaScrollY < -100) {
        this.setHidden(false);
      }

    } else {
      this.deltaScrollY = 0;
    }

    this.lastScrollY = scrollY;
  }

  onBreakpointChange (breakpoint) {

    // at breakpoints s and m there is a two-column layout
    // check if we are changing from or to that two-column layout
    const multiColumnLayout = (breakpoint === 's' || breakpoint === 'm');
    if (this.multiColumnLayout !== multiColumnLayout) {
      this.multiColumnLayout = multiColumnLayout;

      // handle layout change
      if (multiColumnLayout) {
        // create second column list element
        this.$secondList = document.createElement('ul');
        this.$secondList.className = 'navigation__list';
        this.$list.parentNode.appendChild(this.$secondList);

        // move half of the items to the second column
        const $elements = [...this.$list.childNodes];
        let i = parseInt(($elements.length - 2) / 2);
        for (; i < $elements.length; i++) {
          this.$secondList.appendChild($elements[i]);
        }
      } else {
        // move elements from the second column list back to the first one
        const $secondaryElements = [...this.$secondList.childNodes];
        $secondaryElements.forEach($node => this.$list.appendChild($node));

        // remove second column list element
        this.$secondList.parentNode.removeChild(this.$secondList);
        this.$secondList = null;
      }
    }
  }
}
